const ErrorRouter = [
    /** Has Any No Permission */
    {
        path: "/has-any-no-permission",
        name: "HasAnyNoPermission",
        component:  () => import('../views/errors/HasAnyNoPermission'),
    },
    /** No Mached Route found */
    {
        path: "/no-mached",
        name: "NoMachedRoute",
        component:  () => import('../views/errors/HasAnyNoPermission'),
    },
];

export default ErrorRouter;